import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Chart } from '@antv/g2';
import { ChartConfig } from '../../utils/chart/chart-config.interface';
import { ChartContent } from '../../utils/chart/chart-content.interface';
import { v4 as uuidv4 } from 'uuid';
import { convertChartConfigToG2Spec } from '../../utils/chart/chart-utils';

@Component({
  selector: 'rappider-chart-base',
  templateUrl: '../chart-base/chart-base.component.html',
  styleUrls: ['./chart-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RappiderChartBaseComponent implements OnInit, AfterViewInit {
  @Input() config: ChartConfig;
  @Input() content?: ChartContent;
  @Input() data?: any[];
  @Input() configAsString?: string;

  defaultHeight = 400;
  uniqueId: string = 'chartContainer_' + uuidv4().replace(/-/g, '');

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    // set a default config
    const defaultConfig = {};

    // merge default config with user config
    this.config = { ...defaultConfig, ...this.config };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.configAsString && this.data) {
        this.renderChartWithData();
      } else {
        this.renderChart();
      }
    }, 300);
  }

  renderChart(): void {
    const containerElement = document.getElementById(this.uniqueId);
    if (!containerElement) {
      return;
    }

    const chart = new Chart({
      container: this.uniqueId,
      autoFit: true,
    });
    const g2SpecConfig = convertChartConfigToG2Spec(this.config);
    chart.options(g2SpecConfig);
    chart.render();
  }

  renderChartWithData(): void {
    const containerElement = document.getElementById(this.uniqueId);
    if (!containerElement || !this.configAsString || !this.data) {
      return;
    }

    try {
      // Step 1: Evaluate the config string to create an object with functions.
      // We wrap the config string in parentheses and add 'return' to get the object back.
      const getConfigObject = new Function(`return (${this.configAsString})`);
      const chartConfigObject = getConfigObject();

      // Step 2: Inject the data from your 'content' input into the config object.
      chartConfigObject.data = this.data;

      // Step 3: Render the chart with the final, combined configuration.
      const chart = new Chart({
        container: this.uniqueId,
        autoFit: true,
      });

      chart.options(chartConfigObject);
      chart.render();

    } catch (error) {
      console.error("Failed to parse chart configuration or render chart:", error);
    }
  }

}
